import { useCallback } from 'react';
import { problemDetailsOf } from '../../api-service';
import { useNotifier } from './notifier-context';

// For requests that bypass the shared error interceptor, so an expected error is not announced as one.
export function useNotifyFailedRequest() {
  const { dispatch } = useNotifier();

  return useCallback(
    async (error: unknown, messageWithoutDetails?: string) => {
      const problem = await problemDetailsOf(error);
      if (problem) {
        const { correlationIdentifier, severity, status, detail, title, timestamp, helpLink, messageTitle } = problem;
        dispatch({
          type: 'notify',
          payload: { correlationIdentifier, severity: severity ?? 'error', status, detail, title, timestamp, helpLink, messageTitle },
        });
      } else if (messageWithoutDetails) {
        dispatch({ type: 'notify', payload: { message: messageWithoutDetails, severity: 'error' } });
      }
    },
    [dispatch]
  );
}
